export const GET_DISTRICT_PROCESSING = "GET_DISTRICT_PROCESSING";
export const GET_DISTRICT_SUCCESS = "GET_DISTRICT_SUCCESS";
export const GET_DISTRICT_FAIL = "GET_DISTRICT_FAIL";

export const GET_PROVINCE_PROCESSING = "GET_PROVINCE_PROCESSING";
export const GET_PROVINCE_SUCCESS = "GET_PROVINCE_SUCCESS";
export const GET_PROVINCE_FAIL = "GET_PROVINCE_FAIL";

export const CREATE_DONER_PROCESSING = "CREATE_DONER_PROCESSING";
export const CREATE_DONER_SUCCESS = "CREATE_DONER_SUCCESS";
export const CREATE_DONER_FAIL = "CREATE_DONER_FAIL";

export const GET_DONER_PROCESSING = "GET_DONER_PROCESSING";
export const GET_DONER_SUCCESS = "GET_DONER_SUCCESS";
export const GET_DONER_FAIL = "GET_DONER_FAIL";

export const GET_SINGLE_DONER_PROCESSING = "GET_SINGLE_DONER_PROCESSING";
export const GET_SINGLE_DONER_SUCCESS = "GET_SINGLE_DONER_SUCCESS";
export const GET_SINGLE_DONER_FAIL = "GET_SINGLE_DONER_FAIL";
